var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data",style:(_vm.borderStyle)},[_c('img',{staticClass:"icon",attrs:{"src":_vm.noDataImg}}),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.tips))])])
}
var staticRenderFns = []

export { render, staticRenderFns }